/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Employment_TypeInputs */

const en_employment_type = /** @type {(inputs: Employment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employment Type`)
};

const de_employment_type = /** @type {(inputs: Employment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anstellungsart`)
};

/**
* | output |
* | --- |
* | "Employment Type" |
*
* @param {Employment_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const employment_type = /** @type {((inputs?: Employment_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Employment_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_employment_type(inputs)
	return en_employment_type(inputs)
});